import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { t } from "../utils/i18n";
import { getCookieConsent, setCookieConsent } from "../utils/cookieConsent";
import { ToggleSwitch } from "./messages/icons";

// Bandeau de consentement cookies, inspiré du modèle Facebook (fondateur) : titre traduit,
// paragraphe explicatif volontairement laissé en anglais (comme chez Facebook), logo OLTODO,
// "Plus d'options" ouvre un second écran avec un choix granulaire ET la possibilité explicite
// de continuer sans accepter — jamais un simple "Accepter"/"Refuser" à deux issues, conforme à ce
// qui a été demandé. OLTODO n'utilise aujourd'hui que du stockage essentiel (voir
// utils/cookieConsent.ts) : le toggle "analyse" est honnêtement annoncé comme non utilisé pour
// l'instant, mais pose déjà l'infrastructure pour gouverner un futur script.
export default function CookieConsentBanner() {
  const { lang } = useApp();
  const [dismissed, setDismissed] = useState(() => !!getCookieConsent());
  const [showOptions, setShowOptions] = useState(false);
  const [analyticsOn, setAnalyticsOn] = useState(false);

  if (dismissed) return null;

  const acceptAll = () => { setCookieConsent(true); setDismissed(true); };
  const continueWithoutAccepting = () => { setCookieConsent(false); setDismissed(true); };
  const saveChoices = () => { setCookieConsent(analyticsOn); setDismissed(true); };

  return (
    <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.4)", zIndex: 5000, display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
      <div style={{ backgroundColor: "white", width: "100%", maxWidth: 480, borderRadius: "20px 20px 0 0", padding: "24px 22px", boxSizing: "border-box", maxHeight: "85vh", overflowY: "auto" }}>
        <img src="/oltodo.png" alt="OLTODO" style={{ width: 40, height: 40, objectFit: "contain", marginBottom: 14, display: "block", marginLeft: "auto", marginRight: "auto" }} />

        {!showOptions ? (
          <>
            <div style={{ fontSize: 19, fontWeight: 800, lineHeight: 1.3, marginBottom: 14 }}>
              {t(lang, "cookie_consent_title")}
            </div>
            <div style={{ fontSize: 14, color: "#444", lineHeight: 1.5, marginBottom: 20 }}>
              We use essential cookies and local storage to keep you signed in, remember your
              language, and keep the app secure. We don't use any advertising or tracking cookies
              today. You can review your choices at any time in our{" "}
              <a href="/cookie-policy" target="_blank" rel="noreferrer" style={{ color: "#0a0a0a", fontWeight: 700 }}>
                {t(lang, "cookie_consent_policy_link")}
              </a>.
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={() => setShowOptions(true)} style={{ flex: 1, padding: "13px", borderRadius: 10, border: "none", backgroundColor: "#F0F2F5", color: "#0a0a0a", fontSize: 14.5, fontWeight: 700, cursor: "pointer" }}>
                {t(lang, "cookie_consent_more_options")}
              </button>
              <button onClick={acceptAll} style={{ flex: 1, padding: "13px", borderRadius: 10, border: "none", backgroundColor: "#0a0a0a", color: "white", fontSize: 14.5, fontWeight: 700, cursor: "pointer" }}>
                {t(lang, "cookie_consent_accept_all")}
              </button>
            </div>
          </>
        ) : (
          <>
            <div style={{ fontSize: 19, fontWeight: 800, marginBottom: 18 }}>{t(lang, "cookie_consent_title")}</div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 0", borderBottom: "1px solid #F0F0F0" }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 600 }}>{t(lang, "cookie_consent_essential_label")}</div>
                <div style={{ fontSize: 12, color: "#999", marginTop: 2 }}>{t(lang, "cookie_consent_essential_always_on")}</div>
              </div>
              <div style={{ opacity: 0.5 }}><ToggleSwitch on /></div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 0", borderBottom: "1px solid #F0F0F0", marginBottom: 20 }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 600 }}>{t(lang, "cookie_consent_analytics_label")}</div>
                <div style={{ fontSize: 12, color: "#999", marginTop: 2 }}>{t(lang, "cookie_consent_analytics_note")}</div>
              </div>
              <div onClick={() => setAnalyticsOn(v => !v)} style={{ cursor: "pointer" }}>
                <ToggleSwitch on={analyticsOn} />
              </div>
            </div>

            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={continueWithoutAccepting} style={{ flex: 1, padding: "13px", borderRadius: 10, border: "1.5px solid #E0E0E0", backgroundColor: "white", color: "#0a0a0a", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
                {t(lang, "cookie_consent_continue_without")}
              </button>
              <button onClick={saveChoices} style={{ flex: 1, padding: "13px", borderRadius: 10, border: "none", backgroundColor: "#0a0a0a", color: "white", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
                {t(lang, "cookie_consent_save_choices")}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
